import React, { useContext, Fragment, useEffect, useState } from 'react';
import { store } from './Tendering';
import { store as mainStore } from '../../../../../store';
import Fade from '@material-ui/core/Fade';
import { __ } from '../../../../../utils/i18n';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { formatNumber, toEN } from '../../../../../fns';
import dotsLoader from '../../../../../assets/svg/dotsLoader.svg';
import FormLabel from '@material-ui/core/FormLabel';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import TextField from '@material-ui/core/TextField';
import axios from '../../../../../api/axios';
import { useHistory, useParams } from 'react-router-dom';
import { rond } from '../../../../../fns/rond';
import { isMobile } from 'react-device-detect';
import { CircularProgress } from '@material-ui/core';
import CallsListModal from './CallingList/CallsListModal';
import { useSearchParams } from 'hooks/useSearchParams';
import ReportsListModal from './ReportsList/ReportsListModal';
import { useDriversList } from 'useStores/useTenderingStore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>div:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  driversStatus: {
    background: '#f1f1f1',
    padding: theme.spacing(1),
    width: isMobile ? '100%' : 500,
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gridGap: theme.spacing(1),
  },
  commissionStatus: {
    background: '#d1c4e9',
    color: '#311b92',
    padding: theme.spacing(1),
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& > div > span:first-child': {
      fontWeight: 'bold',
    },
    '& > div > span:last-child': {
      marginLeft: theme.spacing(1),
    },
  },
  orderDetails: {
    background: '#bbdefb',
    color: '#0d47a1',
    padding: theme.spacing(1),
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    '& > div:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
    '& > div > span:first-child': {
      fontWeight: 'bold',
    },
    '& > div > span:last-child': {
      marginLeft: theme.spacing(1),
    },
  },
  driversShare: {
    color: '#000',
  },
  commissionType: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const FullContent = () => {
  const classes = useStyles();
  const {
    state: { order, params },
    dispatch,
    actions: { changeStatus },
    refresh,
  } = useContext(store);
  const [urlParams, setParams, deleteParams] = useSearchParams();
  const { showMessage, showError } = useContext(mainStore);
  const history = useHistory();
  const proposedPrice = order && order.proposedPrice ? order.proposedPrice : 0;
  const { id } = useParams();
  const [loadingOrderStatusChange, setLoadingOrderStatusChange] = useState({
    name: '',
    loading: false,
  });
  const { freightsOrderId } = order;
  const reportOfFreightOrder = useDriversList(
    (state) => state.reportOfFreightOrder
  );
  const reportsCount = reportOfFreightOrder?.resultOfDriversCalls?.docs?.length;
  const callsCount = useDriversList((state) => state.callsCount);

  const handleClick = async () => {
    try {
      setLoadingOrderStatusChange({ name: 'tendering', loading: true });
      const data = await changeStatus(order._id, 'tendering');
      data?.ok && showMessage(data.messages);
      dispatch({ type: 'ORDER', payload: data.order });
      document.location.reload();
    } catch (error) {
      showError(error);
    } finally {
      setLoadingOrderStatusChange({ name: 'tendering', loading: false });
    }
  };
  const handleChangeWaybillType = async (e, value) => {
    dispatch({ type: 'CHANGE_WAYBILL_TYPE', payload: value });
    try {
      const data = {
        orderId: order._id,
        waybillType: value,
      };
      if (value === 'custom') {
        return;
      }
      const { data: result } = await axios.post(
        `/api/v1/admin/orders/changeWaybillType`,
        data
      );
      refresh();
      showMessage(result.messages);
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeCustomCommission = (e) => {
    let { value } = e.target;
    value = toEN(value);
    dispatch({ type: 'CHANGE_CUSTOM_COMMISSION', payload: value });
  };
  const handleChangeWaybillClick = async () => {
    try {
      const data = {
        orderId: order._id,
        waybillType: order.waybillType,
      };
      if (order.waybillType === 'custom') {
        data.customCommission = order.customCommission
          ? order.customCommission
          : 0;
      }
      const { data: result } = await axios.post(
        `/api/v1/admin/orders/changeWaybillType`,
        data
      );
      refresh();
      showMessage(result.messages);
      // setTimeout(() =>{history.push(`/protected/admin/orders/getWaybill/${order._id}`)},1000)
    } catch (error) {
      showError(error);
    }
  };
  const handleClickChangeOrderStatus = async () => {
    try {
      setLoadingOrderStatusChange({ name: 'getWaybill', loading: true });
      const { messages } = await changeStatus(order._id, 'getWaybill');
      showMessage(messages);
      history.replace(`/protected/admin/orders/${order._id}`);
    } catch (error) {
      showError(error);
    } finally {
      setLoadingOrderStatusChange({ name: 'getWaybill', loading: false });
    }
  };

  const handleShowCallListModal = () => {
    setParams([{ name: 'callListModal', value: true }]);
  };
  const handleCloseCallListModal = () => {
    deleteParams([{ name: 'callListModal' }]);
  };
  const handleShowReportListModal = () => {
    setParams([{ name: 'reportListModal', value: true }]);
  };
  const handleCloseReportistModal = () => {
    deleteParams([{ name: 'reportListModal' }]);
  };

  return (
    <div className={classes.root}>
      <CallsListModal
        open={urlParams.get('callListModal')}
        onClose={handleCloseCallListModal}
        id={freightsOrderId}
      />
      <ReportsListModal
        open={urlParams.get('reportListModal')}
        onClose={handleCloseReportistModal}
        id={freightsOrderId}
      />
      <div>
        سفارش شما در وضعیت{' '}
        <span style={{ color: 'red', fontWeight: 'bold' }}>
          {__(order.status)}
        </span>{' '}
        میباشد.
        {order && order.status !== 'tendering' ? (
          <Button
            variant="contained"
            size="large"
            color="secondary"
            style={{ marginRight: 15 }}
            onClick={handleClick}
            disabled={loadingOrderStatusChange.loading}
            endIcon={
              loadingOrderStatusChange.loading &&
              loadingOrderStatusChange.name === 'tendering' ? (
                <CircularProgress size={'10px'} />
              ) : (
                <></>
              )
            }
          >
            تغییر وضعیت سفارش به در حال مناقصه
          </Button>
        ) : null}
        {order && order.drivers && order.drivers.length === order.fleetCount ? (
          <Button
            variant="contained"
            size="large"
            color="secondary"
            style={{ marginRight: 15 }}
            onClick={handleClickChangeOrderStatus}
            disabled={loadingOrderStatusChange.loading}
            endIcon={
              loadingOrderStatusChange.loading &&
              loadingOrderStatusChange.name === 'getWaybill' ? (
                <CircularProgress size={'10px'} />
              ) : (
                <></>
              )
            }
          >
            تغییر وضعیت سفارش به صدور بارنامه
          </Button>
        ) : null}
      </div>
      <div className={classes.driversStatus}>
        <div>تعداد رانندگان مورد نیاز:{order.fleetCount}</div>
        <div>
          تعداد رانندگان انتخاب شده:
          {order.drivers && order.drivers.length ? order.drivers.length : 0}
        </div>
        <div>
          تعداد رانندگان بازاریابی شده:
          {order.driversGetNotified && order.driversGetNotified.length
            ? order.driversGetNotified.length
            : 0}
        </div>
        <div>
          تعداد رانندگان در مناقصه:
          {order.bidders && order.bidders.length ? order.bidders.length : 0}
        </div>
      </div>
      <div className={classes.orderDetails}>
        <div>
          <span>مبدا بارگیری:</span>
          <span>{order?.origin?.title || null}</span>
        </div>
        <div>
          <span>مقصد:</span>
          <span>{order?.destination?.title || null}</span>
        </div>
        <div>
          <span>ناوگان مورد نیاز:</span>
          <span>
            {order?.fleetOptions
              ?.map((f) => `${f?.fleet?.title}(${f?.title})`)
              ?.join('، ') || null}
          </span>
        </div>
      </div>
      {params ? (
        <div className={classes.commissionStatus}>
          <div>
            <span>پیشنهاد صاحب‌بار:</span>
            <span>
              {proposedPrice
                ? formatNumber(proposedPrice) + ' تومان'
                : 'توافقی'}
            </span>
          </div>
          <div>
            <span>کارمزد شرکت:</span>
            <span>
              {proposedPrice
                ? formatNumber(params?.commissions || 0) + ' تومان'
                : 'توافقی'}
            </span>
          </div>
          <div>
            <span>بیمه بار:</span>
            <span>{formatNumber(params?.insurance || 0)} تومان</span>
          </div>
          <div className={classes.driversShare}>
            <span>صافی رانندگان:</span>
            <span>
              {proposedPrice
                ? formatNumber(proposedPrice - params.subs) + ' تومان'
                : 'توافقی'}
            </span>
          </div>
          <div style={{ border: '1px solid #000', padding: 5 }}>
            <span>کمیسیون دریافتی:</span>
            <span>
              {proposedPrice ? formatNumber(params.subs) + ' تومان' : 'توافقی'}
            </span>
          </div>
        </div>
      ) : (
        <div>
          <img width={50} src={dotsLoader} alt="" />
        </div>
      )}
      <div className={classes.commissionType}>
        <FormLabel>نوع بارنامه</FormLabel>
        <ToggleButtonGroup
          value={!!order.waybillType ? order.waybillType : 'software'}
          exclusive
          name="waybillType"
          onChange={handleChangeWaybillType}
          size="small"
          style={{ marginRight: 10 }}
        >
          <ToggleButton
            key="w1"
            value="software"
            className={classes.toggleButton}
          >
            نرم‌افزار
          </ToggleButton>
          <ToggleButton
            key="w2"
            value="police"
            className={classes.toggleButton}
          >
            پلیس‌راهی
          </ToggleButton>
          {proposedPrice && (
            <ToggleButton
              key="w3"
              value="custom"
              className={classes.toggleButton}
            >
              سفارشی
            </ToggleButton>
          )}
        </ToggleButtonGroup>
        {order.waybillType === 'custom' ? (
          <TextField
            value={
              order.customCommission ? formatNumber(order.customCommission) : 0
            }
            onChange={handleChangeCustomCommission}
            variant="outlined"
            size="small"
            style={{ marginRight: 10 }}
            label="کارمزد دریافتی"
          />
        ) : null}
        {order.waybillType === 'custom' && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleChangeWaybillClick}
            fullWidth={isMobile ? true : false}
            style={{ marginTop: isMobile ? 10 : 0 }}
          >
            ذخیره
          </Button>
        )}
        <Button
          onClick={handleShowReportListModal}
          variant={'contained'}
          color="secondary"
          size="small"
          className="me-2"
        >
          مشاهده گزارشات: {reportsCount || 0}
        </Button>
        <Button
          onClick={handleShowCallListModal}
          variant={'contained'}
          color="primary"
          size="small"
          className="me-2"
        >
          مشاهده تماس ها: {callsCount.length}
        </Button>
      </div>
    </div>
  );
};
export default React.memo(FullContent);
